import React, {useRef, useState} from 'react';
import {EmployeeCompany} from "../../../../models/EmployeeCompany";
import EntityList from "../../EntityList";
import {TableColumn} from "../../../table/Table";
import TableColumnFactory from "../../TableColumnFactory";
import {EntityDialog} from "../../EntityDialog";
import {makeCreateAction} from "../../../table/TableActionFactory";
import useCrudController from "../../useCrudController";
import {useRbac} from "@gsb/react-rbac";
import {Paper} from "@material-ui/core";
import Detail from "./Detail";
import {useRepo} from "../../../../repos/useRepo";
import {actions} from "../../../../rbac";

export default function List() {
    const { employeeCompanyRepo } = useRepo();
    const { can } = useRbac();


    const permissions = {
        update: can(actions.employeeCompany.update),
        delete: can(actions.employeeCompany.delete),
        create: can(actions.employeeCompany.create)
    };

    const tableRef = useRef<any>(null);
    const reloadData = () => tableRef.current.onQueryChange();

    const columns: TableColumn<EmployeeCompany>[] = TableColumnFactory.withTimestampColumns([
        TableColumnFactory.makeEmployeeCompanyIdColumn(),
        TableColumnFactory.fromProperty("Name", "name"),
    ]);

    const [draft, setDraft] = useState<Partial<EmployeeCompany>>();

    const { _save, _delete, _list} = useCrudController(employeeCompanyRepo, reloadData);
    const [displayAddForm, setDisplayAddForm] = useState(false);

    function renderDetailDialog(onSave: () => Promise<void>,
                                onDelete: () => void,
                                onDismiss: () => void,
                                entity?: EmployeeCompany) {
        return (
            <EntityDialog
                permissions={permissions}
                onSave={onSave}
                onDelete={onDelete}
                onDismiss={onDismiss}
            >
                {(formProps) => (
                    <Detail
                        company={entity}
                        isReadOnly={!!entity && !permissions.update}
                        onValuesChange={setDraft}
                        {...formProps}
                    />
                )}
            </EntityDialog>
        )
    }

    const renderAddNewDialog = () => renderDetailDialog(
        _save(undefined, draft, () => setDisplayAddForm(false)),
        () => setDisplayAddForm(false),
        () => setDisplayAddForm(false),
    );

    return (
        <div>
            <Paper>
                <EntityList
                    title='Employee Companies'
                    columns={columns}
                    fetchData={_list}
                    tableRef={tableRef}
                    actions={[
                        makeCreateAction(() => setDisplayAddForm(true), { hidden: !permissions.create }),
                    ]}
                    renderDetail={(company, onComplete) => renderDetailDialog(
                        _save(company, draft, onComplete),
                        _delete(company, onComplete),
                        onComplete,
                        company
                    )}
                />
            </Paper>
            {displayAddForm && permissions.create && renderAddNewDialog()}
        </div>
    );
}



